import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { brandColors, chartSettings } from '../common/const'

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface CountHitChartProps {
  labels: string[]
  dataSet: number[]
  chartTitle: string
  dataLabel: string
}

export const CountHitChart: React.FC<CountHitChartProps> = ({ labels, dataSet, chartTitle, dataLabel }) => {
  const data: ChartData<'bar'> = {
    labels,
    datasets: [
      {
        label: dataLabel,
        data: dataSet,
        backgroundColor: brandColors.warning,
        stack: 'impacts',
        borderWidth: 0,
        borderRadius: 0,
      }
    ],
  }

  return <Bar data={data} options={{
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: chartTitle,
      },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true },
    },
  }} {...chartSettings} />
}
